<div class="service-catalog-widget">
  <section class="service-catalog-widget-content">
    <h5 class="service-catalog-widget-content-subtitle">
      {{ 'platformWidget.serviceCatalog.subtitle' | transloco }}
    </h5>
  </section>

  <markant-button
    class="flex-row-end"
    colorScheme="primary"
    data-cy="navigate-to-catalog-from-services-widget-btn"
    [routerLink]="['cartridge', 'catalog']"
  >
    <span>{{ 'platformWidget.serviceCatalog.link' | transloco }}</span>
    <markant-icon icon="m_arrow-right" slot="icon-trailing"></markant-icon>
  </markant-button>
</div>
